import { GET, POST } from "../../api/api";

async function voucher_list(param) {
  try {
    const res = await GET("vouchers", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

async function voucher_sell(param) {
  try {
    const res = await POST("vouchers/sell", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export { voucher_list, voucher_sell };
